module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Big-Little-Lies-S2.57b8410.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Big-Little-Lies-S2.jpg
// module id = NnNj
// module chunks = 0